const ACTION_CREATE_LIMIT = 15;

// Only the total number of Actions you can create is capped; activation is unlimited.
export const useActionLimit = () => ({
  createLimit: ACTION_CREATE_LIMIT,
});
